import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from 'react-bootstrap-5';

import Tooltip from 'components/tooltip';

import './styles.scss';
import classNames from 'classnames';

type ClickableIconProps = {
  className?: string;
  disabled?: boolean;
  icon: IconProp;
  size?: SizeProp;
  tooltip?: string;
  onClick?: (event: React.MouseEvent) => void;
}

export default function ClickableIcon(
  { className, disabled = false, icon, size, tooltip, onClick }: ClickableIconProps) {
  const content = <FontAwesomeIcon icon={icon} size={size} />;
  if (tooltip) {
    return (
      <Tooltip content={tooltip}>
        <Button
          aria-label={tooltip}
          className={classNames('clickable-icon', className, size, { disabled })}
          disabled={disabled}
          variant="link"
          onClick={onClick}
        >
          {content}
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      className={classNames('clickable-icon', className, size, { disabled })}
      disabled={disabled}
      variant="link"
      onClick={onClick}
    >
      {content}
    </Button>
  );
}
